import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";
import { isoDateToString } from "../../util/format-date";
import { MdBusiness } from "react-icons/md";
import { FaUserCircle } from "react-icons/fa";

export default function PartnerCard({ partner }) {
  const { navigate } = useContext(UtilityContext);
  return (
    <div
      onClick={(e) => navigate("/partners/info?id=" + partner.id, e)}
      className="grid items-center gap-4 text-sm lg:grid-cols-5 pill"
    >
      <div className="flex items-center space-x-4">
        {partner.photo ? (
          <img src={partner.photo} className="w-10 h-10 rounded-full" />
        ) : partner.type === "business" ? (
          <MdBusiness className="text-3xl icon" />
        ) : (
          <FaUserCircle className="text-3xl icon" />
        )}
        <p className="font-semibold text-stone-200">
          {partner.businessName || partner.name}
        </p>
      </div>

      <div className="text-center lg:text-left text-stone-200 lg:col-span-2">
        <p className="text-stone-200">{partner.phone || "-"}</p>
        <p className="text-stone-200">{partner.email}</p>
      </div>
      <div className="hidden text-left lg:block text-stone-400 lg:col-span-2">
        <p className="">{isoDateToString(partner.dob) || "-"}</p>
        <p className="">{partner.address}</p>
      </div>
    </div>
  );
}
